import { waiverStatusLowerCase, WaiverType } from "@toorak/tc-common-fe-sdk";

const { rejected, approvedConditionally, approved } = waiverStatusLowerCase;

export const nonRescindWaiverStatus = [
  rejected,
  approved,
  approvedConditionally
];

export const isRescindAllowed = (
  waiverResponseType: any,
  waiverType: WaiverType
) => {
  const { evaluationResult, adjustmentWaiver } = WaiverType;
  return (
    !nonRescindWaiverStatus.includes(waiverResponseType?.toLowerCase()) &&
    ![evaluationResult, adjustmentWaiver].includes(waiverType)
  );
};
